import React, {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useReducer,
  useRef,
  useState,
} from 'react'
import './TodoListContentPage.scss'
import store, {
  RootState,
  AppDispatch,
  useAppDispatch,
  notesSlice,
  methods,
  reducer,
} from '../store'
import { useSelector, useDispatch } from 'react-redux'
import { bindEvent } from '../modules/bindEvent'
import { useTranslation } from 'react-i18next'
import { CategoryItem, NoteItem, PageItem } from '../store/notes/typings'

import {
  configSlice,
  eventListener,
  initialConfigState,
  saass,
} from '../store/config'
import { IContext } from '../store'
import { protoRoot } from '../protos'
import {
  getDefaultLabels,
  getImportanceColor,
  getParentIds,
  getSubTodoCount,
  getSubTodoIds,
  getTodoList,
  getTodoProgress,
  getTopParentId,
  initSubTodoCountMap,
} from '../store/notes/todolist'

import {
  SakiButton,
  SakiCheckbox,
  SakiDropdown,
  SakiIcon,
  SakiRow,
  SakiCheckboxItem,
  SakiContextMenu,
  SakiContextMenuItem,
  SakiMenuItem,
} from './saki-ui-react/components'
import { storage } from '../store/storage'
import { deepCopy, getShortId } from '@nyanyajs/utils'
import { LabelItem } from './AsideContent'

const initValue = {
  title: '',
  importance: 0 as 0 | 5 | 4 | 3 | 2 | 1,
  addSubTodoId: '',
  addSubTodoTitle: '',
  addSubTaskTypingId: '',
  selectTodoIds: [] as string[],
  todoList: [] as protoRoot.note.ITodoListPageItem[],
  todoListRenderData: [] as {
    list: {
      todo: protoRoot.note.ITodoListPageItem
      level: number
    }[]
    status: number
    count: number
  }[],

  sortOldId: '',
  sortOldPageX: 0,
  sortDragging: false,
  sortNewId: '',

  sortNewLevel: 1,
  sortOldLevel: 1,

  sortSubTodoIds: [] as string[],

  sortPId: '',

  pLevelMap: {} as {
    [cid: string]: {
      pLevel: number
      pId: string
    }
  },
  // levelMap: {} as {
  // 	[id: string]: number
  // },

  importanceBorderMap: {} as {
    [todoId: string]: number
  },
  // todoItemContextMenuEl: undefined as any,

  showContext: {
    x: 0,
    y: 0,
    label: '',
    visible: false,
  },
}

const DataContext = createContext<IContext<typeof initValue>>({
  state: initValue,
  setState: () => {},
})

// let todoItemContextMenuEl: any

const TodoListContentPage = ({
  noteId,
  categoryId,
  page,
}: {
  noteId: string
  categoryId: string
  page: protoRoot.note.IPageItem
}) => {
  const { t, i18n } = useTranslation('todoPage')
  const config = useSelector((state: RootState) => state.config)
  const notes = useSelector((state: RootState) => state.notes)
  const displayItems = useSelector(
    (state: RootState) => state.config.pageConfig.todolistPage.displayItems
  )
  const dispatch = useDispatch<AppDispatch>()

  const [state, setState] = useReducer(reducer<typeof initValue>, initValue)

  const pageId = page?.id || ''

  const [openDisplayItems, setOpenDisplayItems] = useState(false)
  const [openSettingsDP, setOpenSettingsDP] = useState(false)

  const todoItemContextMenuEl = useRef<any>()

  useEffect(() => {
    if (state.showContext.visible && todoItemContextMenuEl.current) {
      todoItemContextMenuEl.current?.show({
        x: state.showContext.x,
        y: state.showContext.y,
        label: state.showContext.label,
      })
      return
    }
  }, [state.showContext.visible])

  useEffect(() => {
    eventListener.on('setTodoImportance', (val) => {
      setState({
        importance: val,
      })
    })
    return () => {
      eventListener.removeEvent('setTodoImportance')
    }
  }, [])

  // console.log('importanceBorderMap', state.importanceBorderMap)

  const addTodo = async () => {
    await dispatch(
      methods.notes.AddTodo({
        noteId,
        categoryId,
        pageId,
        data: {
          title: state.title,
          importance: state.importance,
        },
      })
    ).unwrap()

    setState({
      title: '',
      importance: 0,
    })
  }

  const getSubTodoList = (parentId: string, l: (typeof state)['todoList']) => {
    state.todoList
      .filter((v) => {
        return v.parentId === parentId
      })
      .forEach((todo) => {
        l.push(todo)
        getSubTodoList(todo?.id || '', l)
      })
    return l
  }

  const getLevel = (
    todoList: protoRoot.note.ITodoListPageItem[],
    todo: protoRoot.note.ITodoListPageItem
  ) => {
    let level = 1
    if (todo.parentId) {
      level += getLevel(
        todoList,
        todoList.filter((sv) => sv.id === todo.parentId)?.[0]
      )
    }
    return level
  }

  const todoProgress = getTodoProgress({
    categoryId,
    noteId,
    pageId,
  })

  useEffect(() => {
    if (page?.type === 'TodoList') {
      // let todoList = (JSON.parse(page?.content || '[]') ||
      // 	[]) as protoRoot.note.ITodoListPageItem[]
      // let todoList = getTodoList({
      // 	noteId,
      // 	categoryId,
      // 	pageId,
      // })
      let todoList = page?.todoList?.filter((v) => (v.status || 0) >= 0) || []

      console.log('todoList1', todoList, page)

      if (!todoList.length && page?.content) {
        todoList = (JSON.parse(page?.content || '[]') ||
          []) as protoRoot.note.ITodoListPageItem[]
      }
      // let todoList = page.todoList?.filter((v) => v.status >= 0) || []

      console.log("page?.type === 'TodoList'", page, todoList)

      const iMap = todoList.reduce(
        (iMap, todo) => {
          if (todo?.id && (todo.importance || 0) > 0 && !todo.parentId) {
            iMap[todo.id] = todo.importance || 0
          }
          return iMap
        },
        {} as typeof state.importanceBorderMap
      )
      setState({
        selectTodoIds: todoList
          .filter((v) => v.status === 1)
          ?.map((v) => v.id || ''),
        todoList,
        importanceBorderMap: todoList.reduce((iMap, todo) => {
          const topPid = getTopParentId(todoList, todo)
          if (todo.parentId && iMap[topPid] > 0) {
            iMap[todo.id || ''] = iMap[topPid]
          }
          return iMap
        }, iMap),

        todoListRenderData: todoList
          .reduce(
            (l, v) => {
              if (v.parentId) return l
              if (
                v.status === 1 &&
                getSubTodoCount(todoList, v?.id || '', [0]) === 0
              ) {
                l[1].push(v)
              } else {
                l[0].push(v)
              }
              return l
            },
            [[], []] as (typeof state.todoList)[]
          )
          .reduce(
            (tr, list, status) => {
              tr[status] = {
                list: [],
                status,
                count: 0,
              }

              tr[status].count = list.length

              list.forEach((sv) => {
                tr[status].list.push({
                  todo: sv,
                  level: getLevel(todoList, sv),
                })
                tr[status].count += getSubTodoCount(
                  todoList,
                  sv?.id || '',
                  [1, 0]
                )
              })

              return tr
            },
            [] as typeof state.todoListRenderData
          ),
      })

      initSubTodoCountMap()
    }
  }, [page?.todoList])

  useEffect(() => {
    console.log('SetLabels labels', page)
    if (page.id && Number(page.status) >= 1 && !page?.labels?.length) {
      const labels = getDefaultLabels()
      // console.log('SetLabels init labels', labels)
      dispatch(
        notesSlice.actions.updatePage({
          noteId: noteId,
          categoryId: categoryId,
          pageId: page.id || '',
          data: {
            labels,
          },
        })
      )
    }
  }, [page])

  // useEffect(() => {
  //   if (!noteId || !categoryId || !pageId) return
  //   const timer = setTimeout(() => {
  //     dispatch(
  //       configSlice.actions.setShowAsideContentModal({
  //         visible: true,
  //         data: {
  //           noteId,
  //           categoryId,
  //           pageId,
  //           todoId: '',
  //           type: 'SetLabels',
  //         },
  //       })
  //     )
  //   }, 4000)

  //   return () => {
  //     clearTimeout(timer)
  //   }
  // }, [noteId, categoryId, pageId])

  return (
    <DataContext.Provider value={{ state, setState }}>
      <div className="todolist-content-page">
        <div className="todolist-item todolist-add">
          <div className="ta-title">
            {/* <saki-checkbox-item
							margin='26px 0 10px 8px'
							value='Add'
						></saki-checkbox-item> */}
            <div className="ta-t-input">
              <div className="ta-top">
                <saki-input
                  ref={bindEvent({
                    changevalue: (e) => {
                      setState({
                        title: e.detail || '',
                      })
                    },
                    pressenter: () => {
                      addTodo()
                    },
                  })}
                  width="100%"
                  height="50px"
                  font-size="14px"
                  value={state.title}
                  placeholder={t('addTask', {
                    ns: 'todoPage',
                  })}
                  placeholder-animation="MoveUp"
                />
              </div>
            </div>
            {/* <saki-icon
        margin='0 10px 0 6px'
        color='#999'
        type='Add'
      ></saki-icon> */}
          </div>
          <div className="ta-bottom">
            <div className="ta-b-left">
              {displayItems.TaskProgressBar ? (
                <div className="ta-b-l-progress">
                  <span>{t('taskProgress')}：</span>
                  <div
                    style={{
                      ...({
                        '--todo-progress': todoProgress.progress + '%',
                      } as any),
                    }}
                    className="TodoListProgress"
                  ></div>
                  <span>
                    {todoProgress.completed}/{todoProgress.total}
                  </span>
                </div>
              ) : (
                ''
              )}
            </div>
            <div className="ta-b-right">
              <ImportanceDropdownComponent
                noteId={noteId}
                categoryId={categoryId}
                pageId={pageId}
                todo={{
                  importance: state.importance,
                }}
              />
              <saki-button
                ref={bindEvent({
                  tap: () => {
                    addTodo()
                  },
                })}
                margin="0 0 0 4px"
                type="Primary"
                disabled={!state.title}
              >
                <span className="p-c-i-i-btn">
                  {t('add', {
                    ns: 'common',
                  })}
                </span>
              </saki-button>
            </div>
          </div>
        </div>

        {state.todoListRenderData.map((v) => {
          const { list, status, count } = v
          // console.log('llllllll', v, l, status, state.todoList.length)
          // const l = state.todoList.filter(
          // 	(sv) =>
          // 		sv.status === v &&
          // 		!sv.parentId &&
          // 		getSubTodoCount(state.todoList, sv?.id || '', [0]) === 0
          // )
          // console.log('todolist1', l)

          // const newList = getTodoList(l)

          // const subTodoMoreCompletedButtonIds: {
          // 	[id: string]: boolean
          // } = {}

          // newList.forEach((todo) => {
          // 	console.log(
          // 		'subTodoMoreCompletedButtonIds',
          // 		todo.parentId,
          // 		todo.status,
          // 		!!(todo.parentId && todo.status >= 1)
          // 	)
          // 	subTodoMoreCompletedButtonIds[todo?.id || ''] = !!(
          // 		todo.parentId && todo.status >= 1
          // 	)
          // })

          // console.log(
          // 	'subTodoMoreCompletedButtonIds',
          // 	subTodoMoreCompletedButtonIds
          // )

          return (
            <div key={status}>
              <div className="todolist-item-title">
                <saki-title margin={status === 0 ? '10px 0' : '10px 0 10px'}>
                  <saki-row justify-content="flex-start" align-items="center">
                    <span>
                      {t(
                        status === 0
                          ? 'todolist'
                          : status === 1
                            ? 'completed'
                            : status === -1
                              ? 'cancelled'
                              : ''
                      )}
                    </span>
                    {displayItems.SubtaskCount && (
                      <span className="completed-count">{count}</span>
                    )}
                  </saki-row>
                </saki-title>

                <div className="tit-right">
                  {status === 0 ? (
                    <SakiDropdown
                      ref={
                        bindEvent({
                          close: () => {
                            setOpenDisplayItems(false)
                          },
                        }) as any
                      }
                      floatingDirection="Left"
                      visible={openDisplayItems}
                    >
                      <SakiButton
                        onTap={() => {
                          setOpenDisplayItems(true)
                        }}
                        padding="6px 8px"
                        border="none"
                      >
                        <SakiRow alignItems="center">
                          <SakiIcon
                            margin="0 4px 0 0"
                            width="14px"
                            height="14px"
                            type="Filter"
                            color="#666"
                          ></SakiIcon>
                          <span
                            style={{
                              color: '#666',
                              fontSize: '12px',
                            }}
                          >
                            {t('displayItems')}
                          </span>
                        </SakiRow>
                      </SakiButton>
                      <div className="todolist-filter-dp" slot="main">
                        <SakiCheckbox
                          onSelectvalue={async (e) => {
                            console.log(e.detail)

                            const items = deepCopy(displayItems) as {
                              [k: string]: boolean
                            }

                            Object.keys(items)
                              .concat(e.detail.values)
                              .forEach((k) => {
                                items[k] = e.detail.values.includes(k)
                              })

                            dispatch(
                              configSlice.actions.setTodoListDisplayItems(
                                items as any
                              )
                            )
                          }}
                          value={Object.keys(displayItems)
                            .filter((k) => {
                              return (
                                displayItems as {
                                  [k: string]: boolean
                                }
                              )[k]
                            })
                            .join(',')}
                          flex-direction="Column"
                          type="Checkbox"
                        >
                          <div className="tr-main">
                            {[
                              {
                                val: 'CompleteCheckbox',
                                text: 'completeCheckbox',
                              },
                              {
                                val: 'TodoId',
                                text: 'taskId',
                              },
                              {
                                val: 'SubtaskCount',
                                text: 'subtaskCount',
                              },
                              {
                                val: 'Labels',
                                text: 'labels',
                              },
                              {
                                val: 'CollapseCompletedSubtasks',
                                text: 'collapseCompletedSubtasks',
                              },
                              {
                                val: 'CollapseButtonOnlyCompletedSubtasks',
                                text: 'collapseButtonOnlyCompletedSubtasks',
                              },
                              {
                                val: 'TaskProgressBar',
                                text: 'taskProgressBar',
                              },
                              {
                                val: 'Importance',
                                text: 'importance',
                              },
                              {
                                val: 'ImportanceBorderColor',
                                text: 'importanceBorderColor',
                              },
                            ].map((v, i) => {
                              return (
                                <SakiCheckboxItem
                                  margin="0 6px 0 0"
                                  value={v.val}
                                  key={i}
                                >
                                  <div className={'tf-item ' + v.val}>
                                    <span className="text-two-elipsis">
                                      {t(v.text)}
                                    </span>
                                  </div>
                                </SakiCheckboxItem>
                              )
                            })}
                          </div>
                        </SakiCheckbox>
                      </div>
                    </SakiDropdown>
                  ) : (
                    ''
                  )}

                  {status === 0 ? (
                    <saki-dropdown
                      visible={openSettingsDP}
                      floating-direction="Left"
                      ref={bindEvent({
                        close: () => {
                          setOpenSettingsDP(false)
                        },
                      })}
                    >
                      <saki-button
                        ref={bindEvent({
                          tap: () => {
                            setOpenSettingsDP(true)
                          },
                        })}
                        margin="0 -2px 0 4px"
                        width="30px"
                        height="30px"
                        type="CircleIconGrayHover"
                      >
                        <saki-icon
                          width="14px"
                          height="14px"
                          color="#666"
                          type={'Settings'}
                        ></saki-icon>
                      </saki-button>

                      <div slot="main">
                        <saki-menu
                          ref={bindEvent({
                            selectvalue: async (e) => {
                              switch (e.detail.value) {
                                case 'SetLabels':
                                  dispatch(
                                    configSlice.actions.setShowAsideContentModal(
                                      {
                                        visible: true,
                                        data: {
                                          noteId,
                                          categoryId,
                                          pageId,
                                          todoId: '',
                                          type: 'SetLabels',
                                        },
                                      }
                                    )
                                  )
                                  break

                                default:
                                  break
                              }
                              setOpenSettingsDP(false)
                            },
                          })}
                        >
                          {[
                            {
                              value: 'SetLabels',
                              text: t('setLabel', {
                                ns: 'todoPage',
                              }),
                            },
                          ].map((v, i) => {
                            return (
                              <SakiMenuItem
                                font-size="14px"
                                value={v.value}
                                padding="10px 16px"
                                key={i}
                              >
                                <span>{v.text}</span>
                              </SakiMenuItem>
                            )
                          })}
                        </saki-menu>
                      </div>
                    </saki-dropdown>
                  ) : (
                    ''
                  )}
                </div>
              </div>

              <saki-checkbox
                ref={bindEvent({
                  selectvalue(e) {
                    const data = {
                      status: e.detail.values.includes(e.detail.value) ? 1 : 0,
                    } as any

                    const todo = page.todoList?.filter(
                      (sv) => sv.id === e.detail.value
                    )?.[0]
                    if (data.status === 1 && todo?.labelId) {
                      data.labelId =
                        page?.labels?.filter((sv) => sv.bindStatus === 1)?.[0]
                          ?.id || ''
                      !data.labelId && delete data.labelId
                    }
                    // console.log('CompleteTodo', e.detail, todo?.labelId, data)

                    dispatch(
                      notesSlice.actions.updateTodo({
                        noteId,
                        categoryId,
                        pageId,
                        todoId: e.detail.value,
                        data: data as any,
                      })
                    )
                  },
                })}
                value={state.selectTodoIds}
                flex-direction="Column"
                type="Checkbox"
              >
                {list.map(({ todo, level }, i) => {
                  // console.log('getLevel', todo.id, getLevel(todo))

                  // console.log(state.subTodoIds.includes(todo.id || ''))

                  //               if (level === 1 && i + 1 <= l.length - 1) {
                  //                 const nTodo = l[i + 1]
                  // //                 completedCount !== 0 &&
                  // // displayItems.CollapseCompletedSubtasks
                  // 								console.log('todotodo', todo, l[i + 1])
                  // 							}
                  return (
                    <TodoItemPage
                      key={todo.id}
                      noteId={noteId}
                      categoryId={categoryId}
                      page={page}
                      todo={todo}
                      // level={1}
                      level={level}
                      show={
                        state.sortOldId && state.sortSubTodoIds.length
                          ? !state.sortSubTodoIds.includes(todo.id || '')
                          : true
                      }
                      sort={status === 0 && config.deviceType !== 'Mobile'}
                    />
                  )
                })}
                {list.length ? (
                  <TodoItemPage
                    key={'blank'}
                    noteId={noteId}
                    categoryId={categoryId}
                    page={page}
                    todo={{
                      id: 'blank;' + list[list.length - 1]?.todo.id,
                      status: 0,
                    }}
                    level={1}
                    show={true}
                    sort={false}
                  />
                ) : (
                  <div className="todolistpage-none">
                    {t('completedAllTaskTip')}
                  </div>
                )}
              </saki-checkbox>
              {/* <saki-drag-sort
									ref={bindEvent({
										chooseValue: (e) => {
											console.log('drag1 chooseValue', e.detail)
											// console.log(
											// 	'ccccc',
											// 	e.detail,
											// 	el,
											// 	el?.getAttribute('data-id')
											// )
											// setState({
											// 	sortOldId: e.detail.oldId,
											// 	sortNewId: '',
											// })
										},
										unchooseValue: () => {
											// setState({
											// 	sortOldId: '',
											// 	sortNewId: '',
											// })
										},
										changeValue: (e) => {
											console.log('drag1 changeValue', e.detail)
										},
										moveValue: (e) => {
											console.log('drag1 moveValue', e.detail)

											setState({
												sortOldId: e.detail.oldId,
												sortNewId: e.detail.newId,
											})
										},
										dragdone: async (e) => {
											console.log('drag1 dragdone', e.detail, state)
											setState({
												sortOldId: '',
												sortNewId: '',
											})
											if (
												!state.sortNewId ||
												!state.sortOldId ||
												e.detail.oldIndex === e.detail.newIndex
											) {
												return
											}
											await dispatch(
												methods.notes.SortTodo({
													noteId,
													categoryId,
													pageId,
													todoId: {
														new: state.sortNewId,
														old: state.sortOldId,
													},
												})
											).unwrap()
										},
									})}
									sort={
										config.deviceType !== 'Mobile' ||
										config.platform === 'Electron'
									}
									padding='0px'
								>
								</saki-drag-sort> */}
            </div>
          )
        })}

        {state.showContext.visible && page?.todoList?.length ? (
          <SakiContextMenu
            ref={
              bindEvent(
                {
                  close: () => {
                    setState({
                      showContext: {
                        x: 0,
                        y: 0,
                        label: '',
                        visible: false,
                      },
                    })
                  },
                },
                (e) => {
                  todoItemContextMenuEl.current = e
                }
              ) as any
            }
            onSelectvalue={async (e) => {
              const value = e.detail.values?.[1]?.value
              if (value === 'Label') {
                const todoId = e.detail.values[1].label
                console.log('Label', value, todoId, e.detail.value)

                dispatch(
                  notesSlice.actions.updateTodo({
                    noteId,
                    categoryId,
                    pageId,
                    todoId,
                    data: {
                      labelId:
                        e.detail.value === 'Cancel' ? 'none' : e.detail.value,
                    },
                  })
                )
                return
              }
              if (e.detail.label === 'SortTo') {
                const todoId = e.detail.values[1].label
                switch (e.detail.value) {
                  case 'MoveToTop':
                    await dispatch(
                      methods.notes.MoveSortTodo({
                        noteId,
                        categoryId,
                        pageId,
                        todoId,
                        type: 'Top',
                      })
                    ).unwrap()
                    break
                  case 'MoveToBottom':
                    await dispatch(
                      methods.notes.MoveSortTodo({
                        noteId,
                        categoryId,
                        pageId,
                        todoId,
                        type: 'Bottom',
                      })
                    ).unwrap()
                    break
                }

                return
              }
              const todoId = e.detail.label
              switch (e.detail.value) {
                case 'Enable':
                  dispatch(
                    notesSlice.actions.updateTodo({
                      noteId,
                      categoryId,
                      pageId,
                      todoId,
                      data: {
                        disable: -1,
                      },
                    })
                  )
                  break
                case 'Disable':
                  dispatch(
                    notesSlice.actions.updateTodo({
                      noteId,
                      categoryId,
                      pageId,
                      todoId,
                      data: {
                        disable: 1,
                      },
                    })
                  )
                  break
                case 'MoveTo':
                  dispatch(
                    configSlice.actions.setShowAsideContentModal({
                      visible: true,
                      data: {
                        noteId,
                        categoryId,
                        pageId,
                        todoId: todoId,
                        type: 'MoveTaskTo',
                      },
                    })
                  )
                  break
                case 'MoveToTop':
                  await dispatch(
                    methods.notes.MoveSortTodo({
                      noteId,
                      categoryId,
                      pageId,
                      todoId,
                      type: 'Top',
                    })
                  ).unwrap()
                  break
                case 'MoveToBottom':
                  await dispatch(
                    methods.notes.MoveSortTodo({
                      noteId,
                      categoryId,
                      pageId,
                      todoId,
                      type: 'Bottom',
                    })
                  ).unwrap()
                  break
                case 'CloseSubtaskInput':
                  setState({
                    addSubTodoId: '',
                    addSubTodoTitle: '',
                  })
                  break
                case 'Add':
                  setState({
                    addSubTodoId: todoId,
                    addSubTodoTitle: '',
                  })
                  break

                case 'Delete':
                  await dispatch(
                    methods.notes.DeleteTodo({
                      noteId,
                      categoryId,
                      pageId,
                      todoId: todoId,
                    })
                  ).unwrap()
                  break

                default:
                  break
              }
            }}
          >
            {(
              [
                state.addSubTodoId
                  ? {
                      icon: 'ArrowLeft',
                      value: 'CloseSubtaskInput',
                      text: t('closeSubtaskInput', {
                        ns: 'common',
                      }),
                    }
                  : {
                      icon: 'Add',
                      value: 'Add',
                      text: t('add', {
                        ns: 'common',
                      }),
                    },

                ...(page?.labels?.length
                  ? [
                      {
                        icon: 'Tag',
                        value: 'Label',
                        text: t('label', {
                          ns: 'todoPage',
                        }),
                        list: page?.labels
                          ?.map((v) => {
                            let id = ''
                            if (state.showContext.label) {
                              id =
                                page.todoList?.filter(
                                  (sv) => sv.id === state.showContext.label
                                )?.[0]?.labelId || ''
                            }
                            return {
                              icon: '',
                              value: v.id,
                              text: v.name,
                              active: id === v.id,
                            }
                          })
                          .concat({
                            icon: '',
                            value: 'Cancel',
                            text: t('cancel', {
                              ns: 'common',
                            }),
                            active: false,
                          }),
                      },
                    ]
                  : []),

                {
                  icon: 'Sort',
                  value: 'SortTo',
                  text: t('sortTo', {
                    ns: 'sakiuiPrompt',
                  }),
                  list: [
                    {
                      icon: 'MoveTop',
                      value: 'MoveToTop',
                      text: t('moveToTop', {
                        ns: 'sakiuiPrompt',
                      }),
                    },
                    {
                      icon: 'MoveBottom',
                      value: 'MoveToBottom',
                      text: t('moveToBottom', {
                        ns: 'sakiuiPrompt',
                      }),
                    },
                  ],
                },
                {
                  icon: 'MoveTo',
                  value: 'MoveTo',
                  text: t('moveTo', {
                    ns: 'sakiuiPrompt',
                  }),
                  // list: state.todoList.map((v) => {
                  // 	return {
                  // 		icon: '',
                  // 		value: v.id,
                  // 		text: v.title,
                  // 	}
                  // }),
                },
                state.todoList.filter(
                  (v) => v.id === state.showContext.label
                )?.[0]?.disable === 1
                  ? {
                      icon: 'Enable',
                      value: 'Enable',
                      text: t('enable', {
                        ns: 'sakiuiPrompt',
                      }),
                    }
                  : {
                      icon: 'Disable',
                      value: 'Disable',
                      text: t('disable', {
                        ns: 'sakiuiPrompt',
                      }),
                    },
                {
                  icon: 'Trash',
                  value: 'Delete',
                  text: t('delete', {
                    ns: 'common',
                  }),
                },
              ] as SakiContextMenuItemComponentType[]
            ).map((sv, si) => {
              return (
                <SakiContextMenuItemComponent
                  key={si}
                  icon={sv.icon}
                  value={sv.value}
                  text={sv.text}
                  textColor={sv.textColor}
                  active={sv.active}
                  list={sv.list}
                />
              )
            })}
          </SakiContextMenu>
        ) : (
          ''
        )}
      </div>
    </DataContext.Provider>
  )
}

const TodoItemPage = ({
  noteId,
  categoryId,
  page,
  todo,
  show,
  level,
  sort,
}: {
  noteId: string
  categoryId: string
  page: protoRoot.note.IPageItem
  todo: protoRoot.note.ITodoListPageItem
  show: boolean
  level: number
  sort: boolean
}) => {
  const { t, i18n } = useTranslation('todoPage')

  const config = useSelector((state: RootState) => state.config)
  const notes = useSelector((state: RootState) => state.notes)
  const displayItems = useSelector(
    (state: RootState) => state.config.pageConfig.todolistPage.displayItems
  )

  const dispatch = useDispatch<AppDispatch>()

  const [showImportanceDropdown, setShowImportanceDropdown] = useState(false)
  const [showMoreDropdown, setShowMoreDropdown] = useState(false)

  const pageId = page?.id || ''

  const todoId = todo?.id || ''

  const { state, setState } = useContext(DataContext)

  const [showCompletedSubtasks, setShowCompletedSubtasks] = useState(
    level !== 1
  )
  const addSubTodo = async () => {
    if (!state.addSubTodoTitle) return
    await dispatch(
      methods.notes.AddTodo({
        noteId,
        categoryId,
        pageId,
        data: {
          title: state.addSubTodoTitle,
          importance: state.importance,
          parentId: state.addSubTodoId,
        },
      })
    ).unwrap()

    setState({
      addSubTodoTitle: '',
      addSubTodoId: '',
      importance: 0,
    })
  }

  const getId = (el: HTMLDivElement): string => {
    const id = el?.getAttribute('data-saki-drag-sort-id') || ''
    if (id) {
      return id
    }
    if (!el || el.classList.contains('todolist-item')) {
      return ''
    }
    return getId(el.parentElement as HTMLDivElement)
  }

  const sortEnd = () => {
    const newLevel = state.sortNewLevel
    const oldLevel = state.sortOldLevel
    const oldId = state.sortOldId
    const newId = state.sortNewId.replace('blank;', '')
    const pId = state.sortPId.replace('blank;', '')
    console.log(
      'sortEnd',
      oldLevel,
      newLevel,
      oldId,
      newId,
      state.pLevelMap,
      state.todoList.filter((v) => v.id === newId || v.id === pId)?.[0]
    )
    setState({
      sortOldId: '',
      sortOldLevel: 1,
      sortNewId: '',
      sortNewLevel: 1,
      sortDragging: false,
    })
    if (!state.sortDragging) return
    if (
      (oldId === newId && oldLevel === newLevel) ||
      (newLevel === 1
        ? state.todoList.filter((v) => v.id === newId || v.id === pId)?.[0]
            ?.status !== 0
        : false)
    ) {
      console.log('sortEnd 无')
      return
    }
    console.log('sortEnd 继续')
    // const pEl = document.body.querySelector(
    // 	`.todolist-item[data-saki-drag-sort-id=${newId}]`
    // )
    // if (
    // 	!state.sortNewId ||
    // 	!state.sortOldId ||
    // 	e.detail.oldIndex === e.detail.newIndex
    // ) {
    // 	return
    // }
    dispatch(
      methods.notes.SortTodo({
        noteId,
        categoryId,
        pageId,
        data: {
          newLevel,
          oldLevel,
          oldId,
          newId,
          pId,
        },
      })
    ).unwrap()
  }

  // levelMap[todo?.id || ''] = level

  let completedCount = 0

  // console.log('completedCount', todoId, completedCount)
  const subTasks = state.todoList.filter((v) => {
    const id = v.id || ''
    if (v.parentId === todoId) {
      if (!displayItems.CollapseCompletedSubtasks) return true
      const notCount = getSubTodoCount(state.todoList, id, [0])
      const count = getSubTodoCount(state.todoList, id, [1])

      if (notCount === 0 && v.status === 1) {
        completedCount += 1 + count
      }
      // if (notCount === 0) {
      // 	completedCount += count
      // }
      // console.log(
      // 	'completedCount',
      // 	todoId,
      // 	id,
      // 	v,
      // 	notCount,
      // 	count,
      // 	!showCompletedSubtasks && notCount === 0 ? v.status === 0 : true
      // )

      return !showCompletedSubtasks && notCount === 0 ? v.status === 0 : true
    }
    return false
  })
  // console.log('subTasks', todoId, subTasks)

  const showAsideContentModal = () => {
    if ((todo?.id || '')?.indexOf('blank') >= 0) return
    const { config } = store.getState()
    const visible = config.pageConfig.asideContentModal.visible
    const { todoId } = config.pageConfig.asideContentModal.data
    dispatch(
      configSlice.actions.setShowAsideContentModal({
        visible: visible && todoId === todo?.id ? false : true,
        data: {
          noteId,
          categoryId,
          pageId,
          todoId: todo?.id || '',
          type: 'Todo',
        },
      })
    )
  }

  const count = getSubTodoCount(state.todoList, todo?.id || '', [1, 0])

  const collapseTodo = useMemo(() => {
    return {
      show: notes.collapseTodoIds.includes(todo?.id || ''),
      setTodoList: (id: string) => {
        let ids = deepCopy(notes.collapseTodoIds)

        if (ids.includes(id)) {
          ids = ids.filter((v) => v !== id)
        } else {
          ids.push(id)
        }

        const allIds = notes.list.reduce((t, v) => {
          v.categories?.forEach((sv) => {
            sv.data?.forEach((ssv) => {
              if (ssv.todoList?.length) {
                ssv.todoList.forEach((sssv) => {
                  t.push(sssv.id || '')
                })
              }
            })
          })
          return t
        }, [] as string[])
        ids = ids.filter((id) => allIds.includes(id))

        dispatch(notesSlice.actions.setCollapseTodoIds(ids))
      },
    }
  }, [notes.collapseTodoIds, todo, dispatch, notes.list])

  const { label } = useMemo(() => {
    return {
      label: page?.labels?.filter((v) => v.id === todo?.labelId)?.[0],
    }
  }, [page?.labels, todo])

  // console.log('subtasks', subTasks)

  return (
    <>
      <div
        key={todo?.id}
        style={{
          // width: `calc(100% - ${18 * (level - 1)}px)`,
          display: show ? 'flex' : 'none',
          ...({
            '--left': `${(level - 1) * 18}px`,
            '--sort-left': `${(state.sortNewLevel - 1) * 18 + (state.sortNewLevel > 1 ? 8 : 0)}px`,
            '--importance-color': `${getImportanceColor(state.importanceBorderMap[todo?.id || ''])}`,
          } as any),

          userSelect: config.deviceType === 'Mobile' ? 'none' : '',

          backgroundColor:
            Number(todo?.importance) > 0
              ? getImportanceColor(todo.importance || 0) + '09'
              : '',
        }}
        data-saki-drag-sort-id={todo.id || ''}
        data-saki-drag-sort-level={level}
        className={
          'todolist-item list-item ' +
          'h' +
          level +
          ' ' +
          ((todo?.id || '')?.indexOf('blank;') >= 0 ? 'blank' : '') +
          ' ' +
          (todo?.id === state.sortNewId &&
          (level === 1 ? todo.status === 0 : true)
            ? 'new-sort-active'
            : '') +
          ' ' +
          (todo?.id === state.sortOldId &&
          (level === 1 ? todo.status === 0 : true)
            ? 'old-sort-active'
            : '') +
          ' ' +
          (state.importanceBorderMap[todo?.id || ''] > 0 &&
          displayItems.ImportanceBorderColor
            ? 'importance'
            : '') +
          ' ' +
          (state.addSubTodoId === todo?.id ? 'showSubtaskInput' : '')
        }
        onMouseDown={(e) => {
          console.log('onMouseDown', e)
        }}
        onDragStart={(e) => {
          console.log('onDragStart')
          const id = getId(e.target as HTMLDivElement)
          const elAll = document.body.querySelectorAll(
            `.todolist-item:not(.todolist-add)`
          )

          const pLevelMap: (typeof state)['pLevelMap'] = {}
          // elAll.item(i)
          elAll.forEach((el, i) => {
            const id = el?.getAttribute('data-saki-drag-sort-id') || ''
            const pId =
              elAll.item(i - 1)?.getAttribute('data-saki-drag-sort-id') || ''
            const pLevel =
              elAll.item(i - 1)?.getAttribute('data-saki-drag-sort-level') || 1
            // console.log('onDragStart', i, id, level)

            pLevelMap[id] = {
              pId,
              pLevel: Number(pLevel),
            }
          })
          // console.log('dr1 onDragStart', e.pageX, id, elAll, pLevelMap)

          let subTodoIds: string[] = []
          if (id) {
            let oldIndex = -1
            state.todoList.some((v, i) => {
              if (v?.id === id) {
                oldIndex = i
              }
              return oldIndex >= 0
            })
            subTodoIds = getSubTodoIds(
              state.todoList,
              state.todoList[oldIndex]?.id || ''
            )
          }

          setState({
            sortOldId: id,
            sortOldLevel: level,
            sortOldPageX: e.pageX,
            pLevelMap,
            sortSubTodoIds: subTodoIds,
          })
        }}
        // onDragEnter={(e) => {
        // 	const id = getId(e.target as HTMLDivElement)
        // 	console.log('dr1 onDragEnter', e.pageX, id)
        // 	setState({
        // 		sortNewId: id,
        // 	})
        // }}
        onDragOver={(e) => {
          console.log('onDragOver', e)
          // const id = getId(e.target as HTMLDivElement)
          const l = Math.floor((e.pageX - state.sortOldPageX) / 16)
          // console.log('dr1 onDragOver', state.pLevelMap)
          if (!state.pLevelMap[todo?.id || '']) return
          const { pId, pLevel } = state.pLevelMap[todo?.id || '']
          // console.log('dr1 onDragOver', {
          // 	sortNewId: todo?.id || '',
          // 	sortPId: pId,
          // 	sortNewLevel: !pId
          // 		? 1
          // 		: l > pLevel + 1
          // 		? pLevel + 1
          // 		: l < 1
          // 		? 1
          // 		: l,
          // })
          setState({
            sortNewId: todo?.id || '',
            sortPId: pId,
            sortDragging: true,
            sortNewLevel: !pId
              ? 1
              : l > pLevel + 1
                ? pLevel + 1
                : l < 1
                  ? 1
                  : l,
          })
        }}
        // onDrag={(e) => {
        // 	const id = getId(e.target as HTMLDivElement)
        // 	console.log('dr1 onDrag', e.pageX, id)
        // }}
        onDragEnd={(e) => {
          console.log('onDragEnd', e)
          // const id =
          // 	(e.target as HTMLDivElement)?.getAttribute(
          // 		'data-saki-drag-sort-id'
          // 	) || ''
          // console.log('dr1 onDragEnd', todo.id)
          // setState({
          // 	sortNewId: id,
          // })
          sortEnd()
        }}
        onTouchStart={(e) => {
          console.log('onTouchStart', e, todoId)
        }}
        onTouchMove={(e) => {
          console.log('onTouchMove', e, todoId)
        }}
        onTouchEnd={(e) => {
          console.log('onTouchEnd', e, todoId)
        }}
        onTouchCancel={(e) => {
          console.log('onTouchCancel', e, todoId)
        }}
        // draggable
        // 在输入的时候禁止脱宅，这样input就可以拖了
        draggable={sort && !(state.addSubTaskTypingId === todo?.id)}
      >
        <div className="ta-title">
          <div className="ta-t-input">
            <div
              onContextMenu={(e) => {
                // console.log(
                //   'todoItemContextMenuEl',
                //   e,
                //   todoItemContextMenuEl.current
                // )

                setState({
                  showContext: {
                    x: e.pageX,
                    y: e.pageY,
                    label: todo.id || '',
                    visible: true,
                  },
                })

                e.preventDefault()
              }}
              className="ta-top"
            >
              <div
                className="ta-t-left"
                onClick={() => {
                  if (config.deviceType !== 'Mobile') {
                    showAsideContentModal()
                  }
                }}
              >
                {displayItems.CompleteCheckbox && (
                  <saki-checkbox-item
                    margin="4px 8px 4px 0"
                    value={todo?.id || ''}
                    // border-radius='50%'
                    padding="4px"
                    icon-size="10px"
                  ></saki-checkbox-item>
                )}

                <div className="ta-t-l-right">
                  <div
                    onClick={() => {
                      if (config.deviceType === 'Mobile') {
                        showAsideContentModal()
                      }
                    }}
                    className={'ta-t-title '}
                  >
                    <span
                      data-count={count}
                      data-id={todo?.id}
                      style={
                        {
                          '--title-padding-count': count ? '24px' : '0px',
                        } as any
                      }
                      className={
                        'ta-t-t-title ' + (todo.disable === 1 ? 'disable' : '')
                      }
                    >
                      {todo?.title?.toString() || ''}
                    </span>

                    {count ? (
                      <div className="ta-t-t-count">
                        <span>{count}</span>
                      </div>
                    ) : (
                      ''
                    )}

                    {label && displayItems.Labels ? (
                      <LabelItem
                        style={{
                          margin: '0 6px 0 6px',
                        }}
                        label={label}
                      ></LabelItem>
                    ) : (
                      ''
                    )}

                    <div className="ta-t-t-add">
                      <saki-button
                        ref={bindEvent({
                          tap: () => {
                            if (
                              state.addSubTodoId &&
                              state.addSubTodoId === todo.id
                            ) {
                              setState({
                                addSubTodoId: '',
                                addSubTodoTitle: '',
                              })
                              return
                            }
                            setState({
                              addSubTodoId: todo?.id || '',
                              addSubTodoTitle: '',
                            })
                          },
                        })}
                        margin="0px 0 0 4px"
                        width="30px"
                        height="30px"
                        bg-color="#eee"
                        bg-hover-color="#ddd"
                        bg-active-color="#ccc"
                        // bg-color='transparent'
                        type="CircleIconGrayHover"
                      >
                        {state.addSubTodoId &&
                        state.addSubTodoId === todo.id ? (
                          <saki-icon
                            width="12px"
                            height="12px"
                            color="#999"
                            type="Top"
                          ></saki-icon>
                        ) : (
                          <saki-icon
                            width="12px"
                            height="12px"
                            color="#999"
                            type="Add"
                          ></saki-icon>
                        )}
                      </saki-button>
                    </div>
                  </div>
                  <div className="ta-t-l-r-bottom">
                    {/* {count ? (
											<div className='ta-t-l-r-b-item count'>{count}</div>
										) : (
											''
										)} */}

                    {todo?.note?.replace(/<\/?.+?>/g, '') ? (
                      <div className="ta-t-l-r-b-item">
                        <saki-icon
                          width="14px"
                          height="14px"
                          color="#999"
                          type="Note"
                        ></saki-icon>
                        <span>
                          {t('note', {
                            ns: 'todoPage',
                          })}
                        </span>
                      </div>
                    ) : (
                      ''
                    )}
                  </div>
                </div>
              </div>
              <div className="ta-t-right">
                {subTasks?.length &&
                (displayItems.CollapseButtonOnlyCompletedSubtasks
                  ? getSubTodoCount(state.todoList, todo.id || '', [1])
                  : true) ? (
                  <div
                    className={`ta-t-t-add ${collapseTodo.show ? 'show' : ''}`}
                  >
                    <saki-button
                      ref={bindEvent({
                        tap: () => {
                          collapseTodo.setTodoList(todo.id || '')
                        },
                      })}
                      margin="0px 4px 0 0"
                      width="30px"
                      height="30px"
                      // bg-color="#eee"
                      bg-hover-color="#ddd"
                      bg-active-color="#ccc"
                      bg-color="transparent"
                      type="CircleIconGrayHover"
                    >
                      <div
                        style={{
                          transform: `rotate(${
                            collapseTodo.show ? '180deg' : '0deg'
                          })`,
                          transition: 'all .3s',
                        }}
                      >
                        <saki-icon
                          width="12px"
                          height="12px"
                          color="#999"
                          type="Bottom"
                        ></saki-icon>
                      </div>
                    </saki-button>
                  </div>
                ) : (
                  ''
                )}
                {displayItems.TodoId && (
                  <span className="ta-text">{todo?.displayId || ''}</span>
                )}

                {displayItems.Importance && (
                  <ImportanceDropdownComponent
                    noteId={noteId}
                    categoryId={categoryId}
                    pageId={pageId}
                    todo={todo}
                  />
                )}

                {/* <saki-dropdown
									visible={showMoreDropdown}
									floating-direction='Left'
									ref={bindEvent({
										close: (e) => {
											setShowMoreDropdown(false)
										},
									})}
								>
									<saki-button
										ref={bindEvent({
											tap: () => {
												setShowMoreDropdown(true)
											},
										})}
										margin='0 4px 0 4px'
										width='30px'
										height='30px'
										bg-color='transparent'
										type='CircleIconGrayHover'
									>
										<saki-icon color='#999' type='More'></saki-icon>
									</saki-button>

									<div slot='main'>
										<saki-menu
											ref={bindEvent({
												selectvalue: async (e) => {
													switch (e.detail.value) {
														case 'Delete':
															await dispatch(
																methods.notes.DeleteTodo({
																	noteId,
																	categoryId,
																	pageId,
																	todoId: todo?.id || '',
																})
															).unwrap()

															break

														default:
															break
													}
													setShowMoreDropdown(false)
												},
											})}
										>
											{['Delete'].map((v, i) => {
												return (
													<saki-menu-item
														padding='14px 18px'
														font-size='14px'
														value={v}
														key={i}
													>
														<span className='text-elipsis'>
															{t(v.toLowerCase(), {
																ns: 'common',
															})}
														</span>
													</saki-menu-item>
												)
											})}
										</saki-menu>
									</div>
								</saki-dropdown> */}
              </div>
            </div>
            {state.addSubTodoId === todo?.id ? (
              <div
                className="ta-add-subtodo"
                // draggable={false}
                // onDragStart={(e) => {
                // 	e.preventDefault()
                // }}
                // onDragOver={(e) => {
                // 	e.preventDefault()
                // }}
                // onDragEnd={(e) => {
                // 	e.preventDefault()
                // }}
                // onDrag={(e) => {
                // 	e.preventDefault()
                // }}
              >
                <div className="ta-b-left">
                  <saki-input
                    ref={bindEvent({
                      changevalue: (e) => {
                        setState({
                          addSubTodoTitle: e.detail || '',
                        })
                      },
                      pressenter: () => {
                        addSubTodo()
                      },
                      focusfunc: () => {
                        setState({
                          addSubTaskTypingId: todo?.id || '',
                        })
                      },
                      blurfunc: () => {
                        setState({
                          addSubTaskTypingId: '',
                        })
                      },
                    })}
                    width="100%"
                    height="50px"
                    font-size="14px"
                    value={state.addSubTodoTitle}
                    background-color="transparent"
                    placeholder={t('addTask', {
                      ns: 'todoPage',
                    })}
                    placeholder-animation={'MoveUp'}
                  />
                </div>
                <div className="ta-b-right">
                  <ImportanceDropdownComponent
                    noteId={noteId}
                    categoryId={categoryId}
                    pageId={pageId}
                    todo={{
                      importance: state.importance,
                    }}
                  />
                  <saki-button
                    ref={bindEvent({
                      tap: async () => {
                        addSubTodo()
                      },
                    })}
                    padding="6px 8px"
                    margin="0 0 0 4px"
                    type="Primary"
                    disabled={!state.addSubTodoTitle}
                  >
                    <span className="p-c-i-i-btn">
                      {t('add', {
                        ns: 'indexPage',
                      })}
                    </span>
                  </saki-button>
                </div>
              </div>
            ) : (
              ''
            )}
          </div>
        </div>
        {/* <div className='ta-subMoreCompletedButton'>
					{'showSubMoreCompletedButton'}
				</div> */}
        <div className="ta-border-bottom"></div>
        {/* <div className='ta-buttons'>
    <div className='ta-b-left'></div>
    <div className='ta-b-right'></div>
  </div> */}
      </div>
      {/* <span>{subTasks.length}</span> */}
      {subTasks
        .filter((v) => {
          if (collapseTodo.show) {
            if (displayItems.CollapseButtonOnlyCompletedSubtasks) {
              const totalCount = getSubTodoCount(
                state.todoList,
                v.id || '',
                [0, 1]
              )

              if (v.id === 'M2jA735es') {
                console.log(
                  'cccccccccccccccccccccc',
                  v.status,
                  getSubTodoCount(state.todoList, v.id || '', [1]) !==
                    totalCount
                )
              }

              // 有子任务
              if (totalCount > 0) {
                return !(
                  getSubTodoCount(state.todoList, v.id || '', [1]) ===
                    totalCount && v.status === 1
                )
              }

              return v.status !== 1
            }
            return false
          }
          return true
        })
        .map((sTodo, i) => {
          // console.log('ccccc', state.sortOldId, todo.id)
          // console.log(
          // 	'subTasks',
          // 	todoId,
          // 	sTodo.id,
          // 	sTodo,
          // 	1,
          // 	state.sortSubTodoIds,
          // 	!!state.sortOldId && state.sortSubTodoIds.length,
          // 	1,
          // 	!!(state.sortOldId && state.sortSubTodoIds.length)
          // 		? !state.sortSubTodoIds.includes(sTodo.id || '')
          // 		: level >= 2
          // 		? false
          // 		: true
          // )
          return (
            <TodoItemPage
              key={sTodo.id}
              noteId={noteId}
              categoryId={categoryId}
              page={page}
              todo={sTodo}
              // level={1}
              level={level + 1}
              show={
                state.sortOldId && state.sortSubTodoIds.length
                  ? !state.sortSubTodoIds.includes(sTodo.id || '')
                  : true
              }
              sort={sort}
            />
          )
        })}

      {/* <span>
				{level},{completedCount}
			</span> */}
      {level === 1 &&
      completedCount !== 0 &&
      displayItems.CollapseCompletedSubtasks ? (
        <div
          style={{
            ...({
              '--importance-color': `${getImportanceColor(state.importanceBorderMap[todo?.id || ''])}`,
            } as any),
          }}
          className={
            'todolist-subtask-morecompletedbutton ' +
            (showCompletedSubtasks ? 'show' : 'hide') +
            ' ' +
            (state.importanceBorderMap[todo?.id || ''] > 0 &&
            displayItems.ImportanceBorderColor
              ? 'importance'
              : '')
          }
        >
          <saki-button
            ref={bindEvent({
              tap: () => {
                collapseTodo.show && collapseTodo.setTodoList(todo.id || '')
                setShowCompletedSubtasks(!showCompletedSubtasks)
              },
            })}
            margin="6px 0"
            border="none"
            title={'仅隐藏或者显示包含所有子任务都完成的'}
          >
            <span>
              {`${t('completedSubtasks', {
                ns: 'todoPage',
              })} (${completedCount})`}
            </span>
            <saki-icon
              width="10px"
              height="10px"
              color="#999"
              type="Bottom"
              margin="0 0 0 6px"
            ></saki-icon>
          </saki-button>
        </div>
      ) : (
        ''
      )}
    </>
  )
}

export const ImportanceDropdownComponent = ({
  noteId,
  categoryId,
  pageId,
  todo,
}: {
  noteId: string
  categoryId: string
  pageId: string
  todo: protoRoot.note.ITodoListPageItem
}) => {
  const dispatch = useDispatch<AppDispatch>()

  const [showImportanceDropdown, setShowImportanceDropdown] = useState(false)
  return (
    <saki-dropdown
      visible={showImportanceDropdown}
      floating-direction="Left"
      ref={bindEvent({
        close: () => {
          setShowImportanceDropdown(false)
        },
      })}
    >
      <saki-button
        ref={bindEvent({
          tap: () => {
            setShowImportanceDropdown(true)
          },
        })}
        margin="0 0 0 4px"
        width="26px"
        height="26px"
        bg-color="transparent"
        bg-hover-color={'#ddd'}
        bg-active-color={'#ccc'}
        type="CircleIconGrayHover"
      >
        <saki-icon
          color={getImportanceColor(todo?.importance || -1)}
          type={(todo?.importance || 0) > 0 ? 'StarFill' : 'Star'}
        ></saki-icon>
      </saki-button>

      <div slot="main">
        <saki-menu
          ref={bindEvent({
            selectvalue: async (e) => {
              console.log('importance', e.detail.value)
              todo.id
                ? dispatch(
                    notesSlice.actions.updateTodo({
                      noteId,
                      categoryId,
                      pageId,
                      todoId: todo.id,
                      data: {
                        importance: Number(e.detail.value) as any,
                      },
                    })
                  )
                : eventListener.dispatch(
                    'setTodoImportance',
                    Number(e.detail.value) as any
                  )

              setShowImportanceDropdown(false)
            },
          })}
        >
          {[5, 4, 3, 2, 1, -1].map((v, i) => {
            return (
              <saki-menu-item font-size="14px" value={v} key={i}>
                <saki-icon
                  color={getImportanceColor(v)}
                  type={!v ? 'Star' : 'StarFill'}
                ></saki-icon>
              </saki-menu-item>
            )
          })}
        </saki-menu>
      </div>
    </saki-dropdown>
  )
}

type SakiContextMenuItemComponentType = {
  icon: string
  value: string
  text: string
  textColor?: string
  active?: boolean
  list: SakiContextMenuItemComponentType[]
}

export const SakiContextMenuItemComponent = ({
  icon,
  value,
  text,
  active,
  textColor,
  list,
}: SakiContextMenuItemComponentType) => {
  return (
    <SakiContextMenuItem
      active={active}
      color={textColor}
      font-size="13px"
      padding="12px 10px"
      value={value}
    >
      <div className="context-menu-item">
        {icon ? (
          <saki-icon
            width={
              icon === 'Add' ||
              icon === 'Tag' ||
              icon === 'Sort' ||
              icon === 'MoveTo'
                ? '14px'
                : '16px'
            }
            height={
              icon === 'Add' ||
              icon === 'Tag' ||
              icon === 'Sort' ||
              icon === 'MoveTo'
                ? '14px'
                : '16px'
            }
            margin="0 6px 0 0"
            type={icon}
          ></saki-icon>
        ) : (
          ''
        )}
        <span className="item-text">{text}</span>
      </div>

      <div slot="SubMenu">
        {list?.length ? (
          <SakiContextMenu label="SortTo">
            {list.map((sv, si) => {
              return (
                <SakiContextMenuItemComponent
                  key={sv.value}
                  icon={sv.icon}
                  value={sv.value}
                  text={sv.text}
                  textColor={sv.textColor}
                  active={sv.active}
                  list={sv.list}
                />
              )
            })}
          </SakiContextMenu>
        ) : (
          ''
        )}
      </div>
    </SakiContextMenuItem>
  )
}

export default TodoListContentPage
